'use strict';

function getCollationReadyString(str, sortIgnore, sortIgnoreCase) {
  if (sortIgnoreCase) {
    str = str.toLowerCase();
  }
  if (sortIgnore) {
    str = str.replace(sortIgnore, '');
  }
  return str;
}

module.exports = getCollationReadyString;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/array/internal/getCollationReadyString.js
// module id = 398
// module chunks = 0